import {AbstractModel, JsonObject, JsonProperty} from '../../../../../../../core/src/public-api';

@JsonObject('model.PricingFormulaItem')
export class PricingFormulaItem extends AbstractModel {

  @JsonProperty(String, 'name')
  name: string;

  @JsonProperty(Number, 'entree')
  entree: number;

  @JsonProperty(Number, 'cost')
  cost: number;

  @JsonProperty(Number, 'extended')
  extended: number;
}
